const parseQuery = (name) => {
    try {
        const arrayStrings = window.location.hash.split('?')[1].split('&').map((element) => {
            return element.split('=');
        });

        return arrayStrings.filter(element => element[0] === name)[0][1];
    } catch (e) {
        return null;
    }
};

export default {
    id: null,
    name: null,
    username: null,
    email: null,
    roleId: null,
    password: null,
    passwordConfirmation: null,
    logged: false,
    token: null,
    image: null,
    currentLang: parseQuery('lang') || window.getAppStorage('locale') || 'en',
    currentDirection: parseQuery('direction') || window.getAppStorage('direction') || 'ltr',
    createdAt: null,
    updatedAt: null,
    certificates: [],
    badges: [],
    workspaceLanguageLoaded: false,
    dashboard: {
        coursesActive: null,
        coursesCompleted: null,
        lessonsCompleted: null,
        skillsAcquired: null,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js